import React, { Component } from "react";
import { debounce } from "lodash";
import { Link } from "react-router-dom";

import { Form, Loading } from "components";

import api from "services/api";

class CustomersForm extends Component {
  state = {
    data: this.props.data,
    customers: [],
    professionals: [],
  };

  constructor(props) {
    super(props);

    this.searchCustomers = debounce(async (value) => {
      if (value.length < 11) {
        this.setState({ customers: [] });
        return;
      }

      try {
        const response = await api.get(`user/v2/inhabitants/cpf/${value}`);
        const { data } = response.data;

        this.setState({
          customers: [
            {
              value: data.id,
              label: `${data.attributes.name} (${value})`,
            },
          ],
        });
      } catch (err) {
        this.setState({ customers: [] });
      }
    }, 300);

    this.searchProfessionals = debounce(async (value) => {
      if (value.length < 11) {
        this.setState({ professionals: [] });
        return;
      }

      try {
        const response = await api.get(`user/v2/inhabitants/cpf/${value}`);
        const { data } = response.data;

        this.setState({
          professionals: [
            {
              value: data.id,
              label: `${data.attributes.name} (${value})`,
            },
          ],
        });

      } catch (err) {
        this.setState({ professionals: [] });
      }
    }, 300);
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldState.data !== data) {
      onChange(data);
    }

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  handleChangeInput = (e) => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleSearchCustomer = (value) => {
    this.searchCustomers(value);
  };

  handleChangeCustomer = (value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, customer: value } });
  };

  handleSearchProfessional = (value) => {
    this.searchProfessionals(value);
  };

  handleChangeProfessional = (value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, professional: value } });
  };

  render() {
    const { data, customers, professionals } = this.state;
    const { saving, onSubmit, errors } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Atribuir cliente EAD</h3>

        <Form.Field>
          <Form.Label>CPF Cliente EAD</Form.Label>
          <Form.Select
            placeholder="Digite o CPF do cliente"
            noOptionsMessage={() => "Nenhum cliente encontrado."}
            options={customers}
            onInputChange={this.handleSearchCustomer}
            onChange={this.handleChangeCustomer}
            value={data.customer}
            isClearable
            errors={errors.customer}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>CPF Profissional EAD</Form.Label>
          <Form.Select
            placeholder="Digite o CPF do profissional"
            noOptionsMessage={() => "Nenhum profissional encontrado."}
            options={professionals}
            onInputChange={this.handleSearchProfessional}
            onChange={this.handleChangeProfessional}
            value={data.professional}
            isClearable
            errors={errors.professional}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Período de Vínculo (em semanas)</Form.Label>
          <Form.Input
            name="duration_days"
            placeholder="Período de Vínculo"
            value={data.duration_days}
            onChange={this.handleChangeInput}
            errors={errors.duration_days}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/professionals/customers" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button
            className="button-save"
            onClick={onSubmit}
            disabled={saving}
          >
            {saving ? (
              <Loading type="btn" size="small" text="Atribuindo..." />
            ) : (
              "Atribuir"
            )}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

export default CustomersForm;
